import React, { useState } from "react";

import { Link } from "react-router-dom";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
import VyntezBuddyLogo from "./VyntezBuddyLogo";
import { useAppToast } from "./AppToastProvider";

const TERMS_POINTS = [
  "Users must provide correct details while booking services.",
  "Vyntez Buddy acts as a service marketplace between consumers and providers.",
  "Service availability and pricing are managed by providers.",
  "Any misuse, fraudulent activity, or abusive behavior may lead to account suspension.",
  "By using this platform, you agree to comply with applicable laws and platform policies."
];

const PRIVACY_POINTS = [
  "We collect user details required for authentication and service fulfillment.",
  "Phone number and profile data are used to connect you with relevant providers.",
  "We do not sell your personal information to third parties.",
  "Data may be processed securely for product improvements and fraud prevention.",
  "You can request profile updates or deletion as per applicable regulations."
];

const HELP_TOPICS = [
  { title: "How do I book a cab?", body: "Open Cab Booking, enter your destination and your minimum fare offer, then choose which driver to approach." },
  { title: "How does OTP login work?", body: "Enter your phone number, request OTP, then verify the code sent by our SignIn service to access your dashboard." },
  { title: "How do I become a provider?", body: "Use the Become Provider option from the header or dashboard to start your provider registration." },
  { title: "Where can I manage my profile?", body: "Go to your account menu after login and choose User Profile or User Addresses." },
  { title: "Is VyntezChat available now?", body: "The VyntezChat launcher is available on every page. Live agent replies are being connected soon." }
];

const LegalTemplate = ({ title, description, points }) => (
  <div className="vb-legal-page">
    <SiteHeader />
    <section className="vb-legal-shell">
      <div className="vb-legal-card">
        <VyntezBuddyLogo compact />
        <h2>{title}</h2>
        <p>{description}</p>
        <ul>
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <Link to="/" className="vb-primary-btn vb-link-btn-solid">
          Back To Home
        </Link>
      </div>
    </section>
    <SiteFooter />
  </div>
);

export const TermsPage = () => (
  <LegalTemplate
    title="Terms and Condition"
    description="These terms govern your use of Vyntez Buddy services and platform access."
    points={TERMS_POINTS}
  />
);

export const PrivacyPage = () => (
  <LegalTemplate
    title="Privacy Policy"
    description="This policy explains how Vyntez Buddy collects, stores, and processes personal information."
    points={PRIVACY_POINTS}
  />
);

export const HelpPage = () => (
  <div className="vb-legal-page">
    <SiteHeader />
    <section className="vb-legal-shell">
      <div className="vb-legal-card">
        <VyntezBuddyLogo compact />
        <h2>Help Center</h2>
        <p>Answers to the most common questions about booking, login, and providers.</p>
        <div className="vb-help-list">
          {HELP_TOPICS.map((topic) => (
            <article key={topic.title} className="vb-help-item">
              <h4>{topic.title}</h4>
              <p>{topic.body}</p>
            </article>
          ))}
        </div>
        <Link to="/" className="vb-primary-btn vb-link-btn-solid">
          Back To Home
        </Link>
      </div>
    </section>
    <SiteFooter />
  </div>
);

export const ContactUsPage = () => {
  const toast = useAppToast();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (event) => {
    event.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.showInfo("Please fill in your name, email, and message.");
      return;
    }
    toast.showSuccess("Thanks! Our team will get back to you shortly.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="vb-legal-page">
      <SiteHeader />
      <section className="vb-legal-shell">
        <div className="vb-legal-card">
          <VyntezBuddyLogo compact />
          <h2>Contact Us</h2>
          <p>+91 98765 43210 · info@vyntezbuddy.com · 4th Floor, Vyntez Towers, Whitefield, Bengaluru, Karnataka 560066, India</p>

          <form className="vb-contact-form" onSubmit={submit}>
            <label>
              <span>Your name</span>
              <input type="text" value={form.name} onChange={(event) => setForm((prev) => ({ ...prev, name: event.target.value }))} />
            </label>
            <label>
              <span>Email</span>
              <input type="email" value={form.email} onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))} />
            </label>
            <label>
              <span>Message</span>
              <textarea rows={4} value={form.message} onChange={(event) => setForm((prev) => ({ ...prev, message: event.target.value }))} />
            </label>
            <button type="submit" className="vb-primary-btn">Send Message</button>
          </form>

          <Link to="/" className="vb-secondary-btn" style={{ marginTop: "1rem", display: "inline-flex" }}>
            Back To Home
          </Link>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
};

